/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
// react library for routing
import { BrowserRouter, Route } from "react-router-dom";
// redux and redux-thunk
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

// firebase
import firebase from 'firebase/app';

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fullcalendar/common/main.min.css";
import "@fullcalendar/daygrid/main.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.0";

// Root reducer
import rootReducer from './reducers';

import App from "./App.js";

// Initialize firebase
const productionConfig = {
  apiKey: "AIzaSyCH5d2AvAtEzmdbMtTsAMPzawUevPkccgk",
  authDomain: "enviro-master-f6cf3.firebaseapp.com",
  projectId: "enviro-master-f6cf3",
  storageBucket: "enviro-master-f6cf3.appspot.com",
  messagingSenderId: "307617610367",
  appId: "1:307617610367:web:257c31c462ac47e9465d4a",
}

const stagingConfig = {
  apiKey: "AIzaSyA7Fw3OHPirMkybUtDfG8ukUTajfHRKNcA",
  authDomain: "enviro-master-staging.firebaseapp.com",
  projectId: "enviro-master-staging",
  storageBucket: "enviro-master-staging.appspot.com",
  messagingSenderId: "1072514326739",
  appId: "1:1072514326739:web:cfe286ebdc1c85ad2fb426",
  measurementId: "G-K71PHYE87R"
}

firebase.initializeApp(process.env.REACT_APP_ENV === 'production' ? productionConfig : stagingConfig)

if (window.location.hostname === 'localhost') {
  console.log('Now running development environment')
  firebase.firestore().settings({
    host: 'localhost:8080',
    ssl: false
  })
  firebase.auth().useEmulator('http://localhost:9099');
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" render={()=><App />} />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
